module.exports = __webpack_public_path__ + "img/sxPic.bc7ee977.jpg";